module.exports = __webpack_public_path__ + "img/unlock.14d60e54.svg";